import { useEffect, useState } from 'react';
import { BsSearch } from 'react-icons/bs';
import Container from '../../components/Container';
import Header from '../../components/Header';
import {
  Stack,
  Box,
  InputGroup,
  InputLeftElement,
  Input,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  TableContainer,
} from '@chakra-ui/react';
import { ActiveProducts } from './components/ActiveProducts';
import { ArchivedProducts } from './components/ArchivedProducts';
import { getArchievedProducts, getUserActiveProducts } from './service';
import { useAuth } from '../../context/authContext';
import FullPageLoader from '../../components/FullPageLoader';
import Footer from '../../components/footer';

const Shop = () => {
  const [inutValue, setInputValue] = useState('');
  const { userInfo } = useAuth();
  const { userId } = userInfo;
  const [loading, setLoading] = useState(false);
  const [archieveProducts, setArchievedProducts] = useState([]);
  const [userActiveproducts, setUserActiveproducts] = useState([]);

  useEffect(() => {
    getArchievedProducts(userId, setLoading, setArchievedProducts);
    getUserActiveProducts(userId, setLoading, setUserActiveproducts);
  }, [userId]);

  const userProducts = userActiveproducts.filter(
    (prod) => prod.status !== 'ARCHIVED'
  );

  return loading ? (
    <FullPageLoader />
  ) : (
    <Stack>
      <Box shadow='sm'>
        <Container>
          <Header menu />
        </Container>
      </Box>

      <Container>
        <InputGroup borderRadius='5px' border='1px solid #FBD5D3'>
          <InputLeftElement fontSize='1.2em' children={<BsSearch />} />
          <Input
            value={inutValue}
            onChange={(e) => setInputValue(e.target.value)}
            border='none'
            placeholder='search...'
          />
        </InputGroup>
        <TableContainer py='5'>
          <Tabs variant='unstyled' isFitted>
            <TabList>
              <Tab {...tabs}>Active Products</Tab>
              <Tab {...tabs}>Archived Products</Tab>
            </TabList>
            <TabPanels>
              <TabPanel px='0'>
                <ActiveProducts data={userProducts} />
              </TabPanel>
              <TabPanel px='0'>
                <ArchivedProducts data={archieveProducts} />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </TableContainer>
      </Container>
      <Footer />
    </Stack>
  );
};

export default Shop;

const tabs = {
  borderRadius: '2px',
  transitionDuration: '500ms',
  fontWeight: 600,
  _selected: { bg: '#614385', color: '#fff' },
  _focus: { border: 'none' },
};
